export const T = {
  en_GB: {
    browse: "Drop a CSV file or click to browse",
    sizeHint: (mb: number) => `.csv up to ${mb} MB`,
    onlyCsv: "Only .csv files are supported.",
    tooLarge: (mb: number) => `File is larger than ${mb} MB.`,
    readFailed: "Failed to read file",
    rows: (n: number) => `${n} rows`,
    replace: "Replace",
    parsing: "Parsing…",
    releaseToUpload: "Release to upload",
    fileFormatError: "Invalid CSV format. Each line must be: date;value (e.g., 2026-01-06;102.5)",
  },
  nb_NO: {
    browse: "Slipp en CSV-fil her eller klikk for å bla",
    sizeHint: (mb: number) => `.csv på opptil ${mb} MB`,
    onlyCsv: "Bare .csv-filer støttes.",
    tooLarge: (mb: number) => `Filen er større enn ${mb} MB.`,
    readFailed: "Kunne ikke lese filen",
    rows: (n: number) => `${n} rader`,
    replace: "Erstatt",
    parsing: "Leser…",
    releaseToUpload: "Slipp for å laste opp",
    fileFormatError: "Ugyldig CSV-format. Hver linje må være: dato;verdi (f.eks. 2026-01-06;102.5)",
  },
} as const;
